import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Avatar Icon (12px) from Figma
 * @link [Figma](https://www.figma.com/design/OcHNCErLKZZwfVXAoIoRas/%F0%9F%8F%A6-Bank-Reconciliation?node-id=9185-3339&m=dev)
 * */
const AvatarIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.37969 10.3394C8.93686 9.89377 8.41029 9.54013 7.83026 9.29882C7.25024 9.0575 6.62822 8.93326 6 8.93326C5.37178 8.93326 4.74976 9.0575 4.16974 9.29882C3.58971 9.54013 3.06314 9.89377 2.62031 10.3394M3.8 5.26667C3.8 5.85014 4.03179 6.40972 4.44437 6.8223C4.85695 7.23488 5.41652 7.46667 6 7.46667C6.58348 7.46667 7.14305 7.23488 7.55563 6.8223C7.96821 6.40972 8.2 5.85014 8.2 5.26667C8.2 4.68319 7.96821 4.12361 7.55563 3.71103C7.14305 3.29845 6.58348 3.06667 6 3.06667C5.41652 3.06667 4.85695 3.29845 4.44437 3.71103C4.03179 4.12361 3.8 4.68319 3.8 5.26667ZM0.5 6C0.5 6.72227 0.642262 7.43747 0.918663 8.10476C1.19506 8.77205 1.60019 9.37837 2.11091 9.88909C2.62163 10.3998 3.22795 10.8049 3.89524 11.0813C4.56253 11.3577 5.27773 11.5 6 11.5C6.72227 11.5 7.43747 11.3577 8.10476 11.0813C8.77205 10.8049 9.37837 10.3998 9.88909 9.88909C10.3998 9.37837 10.8049 8.77205 11.0813 8.10476C11.3577 7.43747 11.5 6.72227 11.5 6C11.5 5.27773 11.3577 4.56253 11.0813 3.89524C10.8049 3.22795 10.3998 2.62163 9.88909 2.11091C9.37837 1.60019 8.77205 1.19506 8.10476 0.918663C7.43747 0.642262 6.72227 0.5 6 0.5C5.27773 0.5 4.56253 0.642262 3.89524 0.918663C3.22795 1.19506 2.62163 1.60019 2.11091 2.11091C1.60019 2.62163 1.19506 3.22795 0.918663 3.89524C0.642262 4.56253 0.5 5.27773 0.5 6Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default AvatarIcon;